import { infrastructuresRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { UpdateAmountDto } from '../types';

export const useUpdateInfrastructureCostAmount = () =>
  useMutation<void, unknown, UpdateAmountDto>((updateAmount) =>
    infrastructuresRepo.updateInfrastructureCostAmount(updateAmount),
  );
